var app = angular.module('leonardo');

var IframeAuthRun = function ($window, $rootScope, CacheService, BroadcastChannelService, $timeout) {
  var ALLOWED_PARENT_ORIGINS = [];
  var DEBUG = window.LEO_DEBUG || false;
  var tokenReceivedFromParent = $window.sessionStorage.getItem('iframe_auth_token_received') === 'true';

  // Set flag on $rootScope for templates to check if running in iframe
  $rootScope.isInIframe = $window.self !== $window.top;

  try {
    if (window.LEO_IFRAME_ALLOWED_ORIGINS) {
      if (typeof window.LEO_IFRAME_ALLOWED_ORIGINS === 'string') {
        ALLOWED_PARENT_ORIGINS = JSON.parse(window.LEO_IFRAME_ALLOWED_ORIGINS);
      } else if (Array.isArray(window.LEO_IFRAME_ALLOWED_ORIGINS)) {
        ALLOWED_PARENT_ORIGINS = window.LEO_IFRAME_ALLOWED_ORIGINS;
      }
    }
  } catch (e) {
    console.error('[IFRAME-AUTH] Failed to parse LEO_IFRAME_ALLOWED_ORIGINS:', e);
  }

  if (DEBUG) {
    console.log('[IFRAME-AUTH] Initialized with allowed origins:', ALLOWED_PARENT_ORIGINS);
    console.log('[IFRAME-AUTH] Running in iframe:', $window.self !== $window.top);
  }

  function isAllowedOrigin(origin) {
    var allowed = ALLOWED_PARENT_ORIGINS.indexOf(origin) !== -1;
    if (DEBUG && !allowed) {
      console.warn('[IFRAME-AUTH] Origin not allowed:', origin, 'Allowed origins:', ALLOWED_PARENT_ORIGINS);
    }
    return allowed;
  }

  function safeParse(data) {
    if (!data) return null;
    if (typeof data === 'object') return data;
    if (typeof data === 'string') {
      try { return JSON.parse(data); } catch (e) { return null; }
    }
    return null;
  }

  function clearAuthStorage() {
    $window.localStorage.removeItem('jwt_token');
    $window.localStorage.removeItem('jwt_token_old');
    $window.localStorage.removeItem('jwt_user_id_old');
    $window.localStorage.removeItem('orig_iat');
    $window.localStorage.removeItem('session_id');
    $window.localStorage.removeItem('auth_provider');
    $window.sessionStorage.removeItem('iframe_auth_token_received');
    tokenReceivedFromParent = false;
    CacheService.clearAll();
  }

  function getParentOrigin() {
    if ($window.document.referrer) {
      try {
        return new URL($window.document.referrer).origin;
      } catch (e) {
        console.error('[IFRAME-AUTH] Failed to parse referrer URL:', e);
      }
    }
    return null;
  }

  function postToParent(message) {
    if ($window.parent === $window) {
      return;
    }
    var parentOrigin = getParentOrigin();
    try {
      if (parentOrigin && isAllowedOrigin(parentOrigin)) {
        $window.parent.postMessage(message, parentOrigin);
      } else {
        ALLOWED_PARENT_ORIGINS.forEach(function (origin) {
          $window.parent.postMessage(message, origin);
        });
      }
    } catch (e) {
      console.error('[IFRAME-AUTH] Failed to post message to parent:', e);
    }
  }

  function isValidJWT(token) {
    // Basic JWT format validation
    if (!token || typeof token !== 'string') {
      return false;
    }

    // JWT should have exactly 3 parts separated by dots
    var parts = token.split('.');
    if (parts.length !== 3) {
      return false;
    }

    // Each part should be non-empty and base64-like (alphanumeric, +, /, -, _)
    var base64Pattern = /^[A-Za-z0-9_-]+$/;
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i] || !base64Pattern.test(parts[i])) {
        return false;
      }
    }

    // Try to decode the header to verify it's valid JSON
    try {
      var header = JSON.parse(atob(parts[0].replace(/-/g, '+').replace(/_/g, '/')));
      // JWT header should have 'typ' and 'alg' fields
      if (!header.typ || !header.alg) {
        return false;
      }
    } catch (e) {
      return false;
    }

    return true;
  }

  $window.addEventListener('message', function (event) {
    if (DEBUG) {
      console.log('[IFRAME-AUTH] Received postMessage from:', event.origin, 'data:', event.data);
    }

    if (!isAllowedOrigin(event.origin)) {
      if (DEBUG) {
        console.log('[IFRAME-AUTH] Message rejected - origin not allowed');
      }
      return;
    }

    var msg = safeParse(event.data);
    if (!msg || !msg.type) {
      if (DEBUG) {
        console.log('[IFRAME-AUTH] Message rejected - invalid format or no type');
      }
      return;
    }

    if (DEBUG) {
      console.log('[IFRAME-AUTH] Processing message type:', msg.type);
    }

    if (msg.type === 'FILTER_DATA' && msg.filters && Object.keys(msg.filters).length > 0) {
      try {
        $window.sessionStorage.setItem('iframe_filter_data', JSON.stringify(msg.filters));
      } catch (e) {
        console.error('[IFRAME-AUTH] Failed to store filter data in sessionStorage:', e);
      }
    }

    if (msg.type === 'AUTH_TOKEN') {
      if (msg.token) {
        // Validate token format before processing
        if (!isValidJWT(msg.token)) {
          console.error('[IFRAME-AUTH] Invalid token format received - rejecting');
          if (DEBUG) {
            console.log('[IFRAME-AUTH] Token validation failed for token:', msg.token.substring(0, 20) + '...');
          }
          return;
        }

        var existingToken = $window.localStorage.getItem('jwt_token');

        if (tokenReceivedFromParent && existingToken) {
          if (DEBUG) {
            console.log('[IFRAME-AUTH] Token already received this session and exists in localStorage, ignoring duplicate');
          }
          return;
        }

        if (tokenReceivedFromParent && !existingToken) {
          if (DEBUG) {
            console.log('[IFRAME-AUTH] Token flag set but token missing from localStorage, clearing flag and processing');
          }
          $window.sessionStorage.removeItem('iframe_auth_token_received');
        }

        if (DEBUG) {
          console.log('[IFRAME-AUTH] Token validation passed - storing in localStorage');
          console.log('[IFRAME-AUTH] Token length:', msg.token.length);
        }

        try {
          $window.sessionStorage.setItem('iframe_auth_token_received', 'true');
          $window.localStorage.setItem('jwt_token', msg.token);
          $window.localStorage.setItem('auth_provider', 'leonardo247');
          $window.localStorage.setItem('orig_iat', new Date().getTime() / 1000);

          if (msg.session_id) {
            $window.localStorage.setItem('session_id', msg.session_id);
          }

          if (DEBUG) {
            console.log('[IFRAME-AUTH] Verification - jwt_token in localStorage:', $window.localStorage.getItem('jwt_token') !== null);
            console.log('[IFRAME-AUTH] Verification - auth_provider:', $window.localStorage.getItem('auth_provider'));
            console.log('[IFRAME-AUTH] Verification - sessionStorage flag:', $window.sessionStorage.getItem('iframe_auth_token_received'));
          }
        } catch (e) {
          console.error('[IFRAME-AUTH] Failed to store token in localStorage:', e);
          return;
        }

        $timeout(() => {
          BroadcastChannelService.postMessage({
            type: 'refresh-token',
            message: 'Token received from parent'
          });
        }, 10);

        if (event.source) {
          try {
            event.source.postMessage(
              { type: 'TOKEN_RECEIVED' },
              event.origin
            );
            if (DEBUG) {
              console.log('[IFRAME-AUTH] Sent TOKEN_RECEIVED acknowledgment');
            }
          } catch (e) {
            console.error('[IFRAME-AUTH] Failed to send TOKEN_RECEIVED:', e);
          }
        }

        if (DEBUG) {
          console.log('[IFRAME-AUTH] Broadcasting iframe-auth:token-received event');
          console.log('[IFRAME-AUTH] Token stored successfully - reloading to trigger authentication');
        }
        $rootScope.$broadcast('iframe-auth:token-received');

        $timeout(() => {
          if (DEBUG) {
            console.log('[IFRAME-AUTH] Reloading page');
          }
          $window.location.reload();
        }, 100);
      } else {
        if (DEBUG) {
          console.warn('[IFRAME-AUTH] AUTH_TOKEN message received but no token provided');
        }
      }
    }

    if (msg.type === 'LOGOUT') {
      if (DEBUG) {
        console.log('[IFRAME-AUTH] Processing LOGOUT message');
      }
      clearAuthStorage();

      $timeout(() => {
        BroadcastChannelService.postMessage({
          type: 'logout',
          message: 'Logout received from parent'
        });
      }, 10);

      $rootScope.$broadcast('iframe-auth:logout-received');
    }
  });

  $rootScope.$on('token-auth:deleted', function () {
    if ($window.self === $window.top) {
      return;
    }
    if (DEBUG) {
      console.log('[IFRAME-AUTH] Revoked token detected in iframe - clearing auth storage and notifying parent');
    }
    clearAuthStorage();
    postToParent({ type: 'UNAUTHORIZED', reason: 'token-revoked' });
  });

  try {
    if ($window.parent && $window.parent !== $window) {
      var hasToken = !!$window.localStorage.getItem('jwt_token');

      // Clear stale flag if token is missing (e.g., after logout)
      if (!hasToken && tokenReceivedFromParent) {
        if (DEBUG) {
          console.log('[IFRAME-AUTH] Token missing but flag exists - clearing stale flag');
        }
        $window.sessionStorage.removeItem('iframe_auth_token_received');
        tokenReceivedFromParent = false;
      }

      var hasFlag = tokenReceivedFromParent;

      if (!hasToken && !hasFlag) {
        // Get parent origin from document.referrer for security
        var parentOrigin = null;

        if ($window.document.referrer) {
          try {
            var referrerUrl = new URL($window.document.referrer);
            parentOrigin = referrerUrl.origin;
          } catch (e) {
            console.error('[IFRAME-AUTH] Failed to parse referrer URL:', e);
          }
        }

        // Validate parent origin against allowed list
        if (parentOrigin && isAllowedOrigin(parentOrigin)) {
          if (DEBUG) {
            console.log('[IFRAME-AUTH] Sending IFRAME_READY to validated parent origin:', parentOrigin);
          }
          $window.parent.postMessage({ type: 'IFRAME_READY' }, parentOrigin);
        } else if (parentOrigin) {
          console.warn('[IFRAME-AUTH] Parent origin not in allowed list:', parentOrigin);
          console.warn('[IFRAME-AUTH] Allowed origins:', ALLOWED_PARENT_ORIGINS);
        } else {
          console.warn('[IFRAME-AUTH] Could not determine parent origin from referrer');
          // Fallback: try sending to each allowed origin
          if (ALLOWED_PARENT_ORIGINS.length > 0) {
            if (DEBUG) {
              console.log('[IFRAME-AUTH] Sending IFRAME_READY to all allowed origins as fallback');
            }
            ALLOWED_PARENT_ORIGINS.forEach(function (origin) {
              $window.parent.postMessage({ type: 'IFRAME_READY' }, origin);
            });
          }
        }
      } else {
        if (DEBUG) {
          console.log('[IFRAME-AUTH] Token or flag exists (token:', !!hasToken, 'flag:', hasFlag, '), skipping IFRAME_READY message');
        }
      }
    } else {
      if (DEBUG) {
        console.log('[IFRAME-AUTH] Not running in iframe, skipping IFRAME_READY message');
      }
    }
  } catch (e) {
    console.error('[IFRAME-AUTH] Failed to send IFRAME_READY:', e);
  }
};

app.run(['$window', '$rootScope', 'CacheService', 'BroadcastChannelService', '$timeout', IframeAuthRun]);
